import React from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js/lib/core';

import pie from 'plotly.js/lib/pie';

import { Box } from '@mui/material';

Plotly.register([pie]);
const Plot = createPlotlyComponent(Plotly);

const PurchaseOrderStatusPie = ({ data = [] }) => {
  const statusCounts = data.reduce((acc, item) => {
    if (item?.transactionstatus) {
      acc[item.transactionstatus] = (acc[item.transactionstatus] || 0) + 1;
    }
    return acc;
  }, {});

  const labels = Object.keys(statusCounts);
  const values = Object.values(statusCounts);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        // Allow Box to resize as per container's width and height
      }}
    >
      <Plot
        data={[
          {
            type: 'pie',
            labels: labels,
            values: values,
            textinfo: 'label+percent',
            insidetextorientation: 'radial',
            marker: {
              colors: ['#AFC6E9', '#0B2545'],
            },
          },
        ]}
        layout={{
          title: {
            font: { size: 18 },
            x: 0.5,
            xanchor: 'center',
          },
          showlegend: true,
          autosize: true,
          height: '100%',
          width: '100%',
          margin: { l: 10, r: 10, t: 40, b: 40 },
          paper_bgcolor: 'transparent',
        }}
        config={{
          responsive: true,
        }}
        style={{
          width: '100%',
          height: '100%',
          transform: 'scale(1)',
          transformOrigin: 'top left', // Scale from top left corner
          transition: 'transform 0.3s ease', // Smooth scaling transition
        }}
      />
    </Box>
  );
};

export default PurchaseOrderStatusPie;
